import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";

import Layout from "../components/Layout";
import Form from "../components/Form";

import usePageMetadata from "../hooks/usePageMetadata";
import useAuthorizedPages from "../hooks/useAuthorizedPages";
import useIsRoleAdmin from "../hooks/useIsRoleAdmin";

const FormScreen = () => {
  const navigate = useNavigate();
  const { localDB, store, form_fields, pageId, title, primary_key } =
    usePageMetadata();
  const { authorizedPages, isCurrentPageAuthorized } = useAuthorizedPages();
  const isRoleAdmin = useIsRoleAdmin();

  useEffect(() => {
    if (!authorizedPages || authorizedPages.length === 0) return;
    if (isCurrentPageAuthorized) return;

    const fallbackPage = authorizedPages[0];
    const destination = isRoleAdmin
      ? `/${fallbackPage}`
      : `/${fallbackPage}/form`;
    navigate(destination, { replace: true });
  }, [
    authorizedPages,
    isCurrentPageAuthorized,
    isRoleAdmin,
    navigate,
  ]);

  if (
    authorizedPages.length > 0 &&
    !isCurrentPageAuthorized
  ) {
    return null;
  }

  return (
    <Layout showMenu>
      <Container component="main" sx={{ maxWidth: { xs: "sm", md: "sm" } }}>
        <Form
          pageId={pageId}
          title={title}
          localDB={localDB}
          store={store}
          fields={form_fields}
          primaryKey={primary_key}
        />
      </Container>
    </Layout>
  );
};

export default FormScreen;
